module.exports = __webpack_public_path__ + "img/hermes_01.3813a061.jpg";